import { asyncLoad } from '@util'
import Optimization from '@components/LocalMerchant/SetMeal/Optimization'
import Introduce from '@components/LocalMerchant/SetMeal/Introduce'
import RelatedCases from '@components/LocalMerchant/SetMeal/RelatedCases'
import WeddingPhotoMeal from '@components/LocalMerchant/JiaMengGoods/WeddingPhotoMeal'
import SetMealCreate from '@components/LocalMerchant/SetMealCreate'
import JiaMengHeader from '@components/JiaMeng/Header/Goods'
import serialManage from './serialManage'
import { isWeddingRingJewelryProperty } from '@merchant-backend/util'

const AsyncSetMeal = asyncLoad(() =>
  import('@components/LocalMerchant/SetMeal/Home')
)

const AsyncOrder = asyncLoad(() =>
  import('@components/LocalMerchant/SetMeal/Order')
)

export default {
  path: 'setMeal',
  component: JiaMengHeader,
  indexRoute: {
    component: AsyncSetMeal
  },
  stat: '套餐管理/首页',
  moduleName: `${isWeddingRingJewelryProperty() ? '商品' : '套餐'}管理`,
  childRoutes: [
    {
      path: 'order',
      component: AsyncOrder,
      stat: '套餐管理/套餐排序',
      title: '套餐排序'
    },
    {
      path: 'optimization',
      component: Optimization,
      stat: '套餐管理/套餐优化'
    },
    {
      path: 'introduce',
      component: Introduce,
      stat: '套餐管理/相关案例'
    },
    {
      path: 'relatedCases(/:id)',
      component: RelatedCases,
      stat: '套餐管理/相关案例'
    },
    {
      path: 'publish/weddingPhotoMeal',
      component: WeddingPhotoMeal,
      stat: '套餐管理/选择婚纱摄影套餐类型'
    },
    {
      path: 'create(/:id)',
      component: SetMealCreate,
      stat: '套餐管理/发布套餐'
    },
    {
      path: 'draftBox',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/SetMeal/DraftBox')
      ),
      stat: '套餐管理/草稿箱',
      title: '草稿箱'
    },
    {
      path: 'review',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/SetMeal/Review')
      ),
      stat: '套餐管理/套餐审核记录',
      title: `${isWeddingRingJewelryProperty() ? '商品' : '套餐'}审核记录`
    },
    {
      ...serialManage
    }
  ]
}
